import DropDownImports from "./imports/DropDownImports"

export default function BotoesForm({ change, setLoadingCSV, navigate, showSuccess }) {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }

    return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 15, flexWrap: "wrap", }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 15, flexWrap: "wrap", }}>
                <DropDownImports change={change} setLoadingCSV={setLoadingCSV} navigate={navigate} showSuccess={showSuccess}/>
            </div>
        </div>
    )
}
